(function (window) {
    window['env'] = window['env'] || {};

    // API url
    window['env']['envApi'] = '${API_URL}';
    window['env']['envApiV2'] = '${API_URL_V2}';
    window['env']['envApp'] = '${APP_URL}';
    window['env']['storageURL'] = '${STORAGE_URL}';
    window['env']['storageBucket'] = '${STORAGE_BUCKET}';
}(this));
